import React from 'react'

function GalleryImageCell({image, index}) {

  const showModal = (e)=>{
    const modal = document.querySelector('#Modal');
    const modalImage = document.querySelector('#Modal-image')
    
    modalImage.src = e.target.src
    modal.showModal()
  }
  const showModalFromKey = (e)=>{
    const modal = document.querySelector('#Modal');
    const modalImage = document.querySelector('#Modal-image')
    if (e.key === 'Enter') {
      
      modalImage.src = e.target.src
      modal.showModal()
    }
  }

  return (
    <div className="gallery-item">
          <img tabIndex={0} onKeyDown={showModalFromKey} onClick={showModal} key={index} src={image} alt="" className="gallery-image" />
        </div>
  )
}

export default GalleryImageCell